var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deck-row",style:({
    'grid-template-columns': _vm.deckColumns,
  })},_vm._l((Object.values(_vm.columns)),function(col,index){return _c('div',{key:`col:${_vm.numberedRow}:${index}`,staticClass:"deck-col"},[_c('seat-map-block',{attrs:{"obj":{
        ..._vm.getObject(col, index),
      }}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }